$(function() {
	var dataUrl = "";
	var link;

	var overlay = $('#overlay');
	$('a[data-overlay]').on('click', function(event) {
		event.preventDefault();

		link = $(this);
		dataUrl = $(this).attr('data-overlay');

		$('body').addClass('show-overlay');

		$.ajax({
			url: dataUrl,
			success: success,
			error: error
		});
	});

	$('#overlay .close').on('click', function(event) {
		event.preventDefault();
		$('body').removeClass('show-overlay');
	});

	function success(data) {
		//overlay.html("<h1>Hello World</h1>");
		overlay.html(data);
	}

	function error(error) {
		window.location.href = link.attr('href');
    }

    function addParameterToURL(url, param) {
        url += (url.split('?')[1] ? '&' : '?') + param;
        return url;
    }

    function removeQueryStringParameter(key, url) {
        if (!url) url = window.location.href;

        var hashParts = url.split('#');

        var regex = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");

        if (hashParts[0].match(regex)) {
            //REMOVE KEY AND VALUE
            url = hashParts[0].replace(regex, '$1');

            //REMOVE TRAILING ? OR &
            url = url.replace(/([?&])$/, '');

            //ADD HASH
            if (typeof hashParts[1] !== 'undefined' && hashParts[1] !== null)
                url += '#' + hashParts[1];
        }

        return url;
    }

    $(document).ready(function () {
        var $baseUrl = removeQueryStringParameter('olo', location.href);
        $('.directlink a[data-id]').each(function () {
            var $newval = addParameterToURL($baseUrl, 'olo=' + $(this).attr('data-id'));
            $(this).attr('href', $newval);
        });

        $('.directlink a[data-id]').on('click', function (event) {
            event.preventDefault();

            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val($(this).attr('href')).select();
            document.execCommand("copy");
            $temp.remove();
        });

        var $directopen = $('.directopen a.fancybox');
        
        if ($directopen) {
            $directopen.trigger('click');
        }
    });
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/overlay/index.js
 **/